import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import { Heading, Page, Container, Link, CircleImage } from '../..';
import { BRAND } from '../../../constants/brand';

import styles from './Training.module.scss';

interface TrainingProps {
  className?: string;
  location?: object;
}

const Training: FunctionComponent<TrainingProps> = ({
  className,
  location,
}) => {
  const trainingClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-training`,
    className,
    {
      [styles.training]: true,
    },
  );

  return (
    <Page className={trainingClass} location={location}>
      <section className={styles.section}>
        <Container>
          <Heading className={styles.heading} level={1}>
            Training Courses
          </Heading>
        </Container>
        <section className={styles.intro}>
          <div className={styles.row}>
            <div className={styles.leftCol}>
              <Container>
                <CircleImage className={styles.circles} images={['1', '5']} />
              </Container>
            </div>
            <div className={styles.rightCol}>
              <Container>
                <Heading level={2}>The UK’s First Tooth Gem Classes</Heading>
                <p>
                  We are pleased to announce we are offering the FIRST and best
                  tooth gem classes in the UK!
                </p>
                <p>
                  Tooth Gems are the perfect service addition for piercers,
                  beauticians or to start a new career. Tooth Gems go hand in
                  hand in tattoo stops as well as Beauty Salons.
                </p>
                <p>
                  With intimate courses of no more than 6 pupils, you will get a
                  hands on approach to learn everything from health and safety,
                  to advance application of Swarovski Crystals as well as Gold
                  Tooth Jewellery.
                </p>
                <p>
                  For a training prospectus, please send an email via the
                  Contact page.
                </p>
              </Container>
            </div>
          </div>
        </section>
        <section className={styles.tutor}>
          <div className={styles.row}>
            <div className={styles.leftCol}>
              <Container>
                <Heading level={2}>Your Tutor</Heading>
                <p>
                  Lana Sophia became interested in Tooth Gems when getting hers
                  done by an American Company. Already a successful brow expert,
                  she thought it would be a super fun addition to her studio.
                  After weeks of research she found that the uk’s training was
                  little more than 90’s infomercial style dvds, with no training
                  in vital elements such as health and safety, hygiene or
                  bedside manner.
                </p>
                <p>
                  Something needed to change! Lana spent months exploring the
                  best products on the dental market, speaking directly to the
                  General Dental Council to ensure the procedure was safe, as
                  well as perfecting the skill.
                </p>
                <p>Thus, Crystal Canine was born!</p>
                <p>
                  Learn from the best! With the finest training the uk’s has to
                  offer, an extensive kit and amazing after care to help you in
                  your career with constant support from Lana!
                </p>
                <p>
                  As well as this, you may also gain the opportunity to join the
                  elite group of Crystal Canine Crew to work alongside Lana at
                  conventions and festival’s around Europe.
                </p>
              </Container>
            </div>
            <div className={styles.rightCol}>
              <Container>
                <figure className={styles.figure}>
                  <img
                    src="/images/lana.gif"
                    alt="Lana Sophia, owner and tutor at Crystal Canine"
                  />
                  <figcaption>Lana Sophia</figcaption>
                </figure>
              </Container>
            </div>
          </div>
          <section className={styles.prospectus}>
            <Heading level={2}>Training Prospectus</Heading>
            <div className={styles.iframeContainer}>
              <iframe
                className={styles.iframe}
                title="Crystal Canine Training Prospectus"
                src="https://online.flipbuilder.com/htgg/bvwi/index.html"
                seamless
                scrolling="no"
                frameBorder="0"
              />
            </div>
          </section>
        </section>
        <section className={styles.learn}>
          <Container>
            <Heading level={3}>Learning From The Best</Heading>
            <p className={styles.detail}>
              Interested in training with Lana and becoming fully qualified in
              the latest trend in the beauty and modification world. Send us a
              message for a prospectus & info on upcoming courses.
            </p>
            <Link
              to="/contact"
              label="Clicking this link will take you through to our contact form."
            >
              Tell me more
            </Link>
          </Container>
        </section>
      </section>
    </Page>
  );
};

export default Training;
